(function () {
  const COOKIE_CONSENT_KEY = 'hmns_cookie_consent';

  function initCookieBanner() {
    const banner = document.getElementById('CookieConsentBanner');
    if (!banner) return;

    const consentStatus = localStorage.getItem(COOKIE_CONSENT_KEY);
    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

    // If user has already made a choice previously (and not in theme editor), do not show banner
    if (consentStatus && !isDesignMode) {
      return;
    }

    // Show banner and lock scroll on first visit
    banner.style.display = 'block';
    document.body.classList.add('cookie-banner-locked');

    const btnAccept = document.getElementById('CookieBtnAccept');
    const btnReject = document.getElementById('CookieBtnReject');
    const btnManage = document.getElementById('CookieBtnManage');

    const modal = document.getElementById('CookieManageModal');
    const modalClose = document.getElementById('CookieModalClose');
    const modalBackdrop = document.getElementById('CookieModalBackdrop');
    const btnSavePreferences = document.getElementById('CookieBtnSavePreferences');

    function hideBanner() {
      banner.style.display = 'none';
      document.body.classList.remove('cookie-banner-locked');
    }

    function notifyConsentAndOpenLocalization() {
      // Dispatch event for other components if needed
      window.dispatchEvent(new CustomEvent('cookie-consent:completed'));
      if (typeof window.openLocalizationModal === 'function') {
        window.openLocalizationModal();
      }
    }

    if (btnAccept) {
      btnAccept.addEventListener('click', () => {
        localStorage.setItem(
          COOKIE_CONSENT_KEY,
          JSON.stringify({
            status: 'accepted',
            essential: true,
            analytics: true,
            marketing: true,
            timestamp: new Date().toISOString(),
          })
        );
        hideBanner();
        notifyConsentAndOpenLocalization();
      });
    }

    if (btnReject) {
      btnReject.addEventListener('click', () => {
        localStorage.setItem(
          COOKIE_CONSENT_KEY,
          JSON.stringify({
            status: 'rejected',
            essential: true,
            analytics: false,
            marketing: false,
            timestamp: new Date().toISOString(),
          })
        );
        hideBanner();
        notifyConsentAndOpenLocalization();
      });
    }

    // Manage Modal interactions
    if (btnManage && modal) {
      btnManage.addEventListener('click', () => {
        modal.style.display = 'flex';
      });
    }

    function closeModal() {
      if (modal) modal.style.display = 'none';
    }

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);

    if (btnSavePreferences) {
      btnSavePreferences.addEventListener('click', () => {
        const analytics = document.getElementById('CookieToggleAnalytics')?.checked ?? false;
        const marketing = document.getElementById('CookieToggleMarketing')?.checked ?? false;

        localStorage.setItem(
          COOKIE_CONSENT_KEY,
          JSON.stringify({
            status: 'customized',
            essential: true,
            analytics: analytics,
            marketing: marketing,
            timestamp: new Date().toISOString(),
          })
        );

        closeModal();
        hideBanner();
        notifyConsentAndOpenLocalization();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBanner);
  } else {
    initCookieBanner();
  }
})();
